import { InstallmentPlanCalculatorComponent } from './installment-plan-calculator.component';
import { runClientComponent } from '../../_common/client/client-component-runner';

runClientComponent({ InstallmentPlanCalculatorComponent: InstallmentPlanCalculatorComponent });
